import React, { useEffect, useState,useRef, useContext } from "react";
import "../components/css/newsletter.css";
import { useNavigate } from "react-router-dom";
import searchIcon from "../images/search-26233.png";
import tekst from "../images/Tekst_img.png";
import picture from "../images/Picture_img.png";
import movie from "../images/Film_img.png";
import movie2 from "../images/film_img1.png";
import trailer from "../images/Trailer_img.png"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import upload from '../images/upload_on_cloud.png'
import deleteIcon  from  '../images/delete.png'
import { keyContext } from "../components/KeyContext";

function NewsletterEditing({chosenTemplate,orgID,setChosenTemplate,saveBtnShown,newsletterNo,sideDiv}) {
  const { openSideDiv, setOpenSideDiv,setEditDiv,editDiv,contentEdit, setContentEdit} = useContext(keyContext)
  const [placeholderID, setPlaceholderID] = useState();
 
  const [newsletterError, setNewsletterError] = useState();
  const key = sessionStorage.getItem("key");
  const [chosenInhold, setChosenInhold] = useState();
  const [contentKey, setContentKey] = useState();
  const [editText, setEditText] = useState('');
  const [files, setFiles] = React.useState([]);
  const [chosenFile, setChosenFile] = useState('VÆLG FIL')
  const [filmSearch, setFilmSearch ]  = useState([])
  const [filterParam, setFilterParam] = useState(["name"]);
  const [searchParam] = useState(["name"]);
  const [q, setQ] = useState("");
  const [movies, setMovies] = useState([{}]);
  const [chosenMovieNo, setChosenMovieNo] = useState();
  const [templateItems, setTemplateItems] = useState([{}]);
  const [imgPath, setImgPath] = useState();
  const [imgLink, setImgLink] = useState();
  const [previewUrl, setPreviewUrl] = useState();
  const [contentDlt, setContentDlt] = useState();
  const [contentInsert, setContentInsert] = useState();
  const [saved, setSaved] = useState();
 let ge = sessionStorage.getItem('newsletter_bio')
   let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]

  // call for newslatter template items get
 useEffect(() => {
    if(key && (orgID || news_orgs)) { 

    const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_templateitems_get?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}`;
     fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then(result => {
         setTemplateItems(result)
    
      })
       }
  }, [key,orgID]);

  useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${news_orgs?news_orgs:orgID}`;
     if(key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
           
      })
      .then(result => setMovies(result.Movies))
    }
  }, [orgID]);

  function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }

   function search(items) {
    
      return items && items.filter((item) => {
       
          if (filterParam == "name") {
              return searchParam.some((newItem) => {
                  return (
                    item[newItem] && item[newItem]
                          .toString()
                          .toLowerCase()
                          .indexOf(q.toLowerCase()) > -1
                  );
              });
          }
      });
     
     }
   
   //------ api call for movie search ------------
     useEffect(() => {
      const endpoint1 = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${'%25'+q+'%25'}`;
     
        if(key && q ) {
   
          fetch( endpoint1, {
            method: "GET",
            headers: {
              ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            },
          })
          .then(res =>  { 
        
            if(res.status === 200) {
              return  res.json() 
    
            }
                  
          })
          .then(result => { 
                 
             
                  if(result) { 
                      // q.length && 
                       setFilmSearch(result)
                  }
                 
             
          
            
          })
         
        }
     },[key,q])

function encodeBase64(str){ 
    return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));  
}
 
  
  function handleContentInsert () {

    const data = chosenInhold === 1  ? { 
      "NewsletterNo" : newsletterNo,
      "html":editText
    }
    : chosenInhold === 2 ? {
      "NewsletterNo" : newsletterNo,
      "ImagePath" : "",
      "Link":""
    } 
    : {
      "NewsletterNo" : newsletterNo,
      "WebMovieNo":chosenMovieNo
    }
  
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_content_insert?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&placeholder=${placeholderID}&TemplateItemNo=${contentKey}&jsonDataBase64=${encodeURIComponent(encodeBase64(JSON.stringify(data)))} `;
    fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
        setChosenTemplate(result.NewBody)
        setChosenInhold()
        setContentKey()
         setOpenSideDiv(false)
         setSaved((current => !current))
        // setEditDiv(false)
        setContentInsert(true)
      })
  } 
  const data = filmSearch.length ?  filmSearch : movies && toFindDuplicates(movies)
  Object.values(filmSearch  ? filmSearch :  toFindDuplicates(movies) )


  function cancelTekstEdit () {
    setContentKey()
    setContentEdit(false)
    setChosenInhold()
  }
    const onDragOver = (ev) => ev.preventDefault();
    const onDropHandler = (ev) => {
            ev.preventDefault();
        
            let file = "";
            if (ev.dataTransfer.items) {
              // Use DataTransferItemList interface to access the file(s)
              file =
                [...ev.dataTransfer.items]
                  .find((item: any) => item.kind === "file")
                  .getAsFile() ;
            } else {
              // Use DataTransfer interface to access the file(s) 
              file = ev.dataTransfer.files[0];
            }
            setFiles([...files, file]);
          };


      function addContent(button) {   }
  
 useEffect(() => {
   
   const handleClick = (e) => {
    
         setPlaceholderID(e.target.offsetParent.id)
          // setContentEdit((current => !current))
           if(saveBtnShown === false || sideDiv === true) {
               setOpenSideDiv((current) => !current);
          }
           else {
             setNewsletterError('nyhedsbrev ikke gemt!')
           }
        };
    const contentAreas = document.querySelectorAll('.content-area')
  
    contentAreas.forEach(area => {
      
      area.style.height='20px'
       const button = area.querySelector('.add-button');
       area.addEventListener('mousemove', (e) => {
                   
                    const rect = area.getBoundingClientRect();
                    const x = e.clientX - rect.left - 20; // Subtract half the button width (40px / 2 = 20px)
                
                    button.style.left = x < 430 ? x + 'px' : '430px';
                    
                addContent(button)
                });
                  button.addEventListener('click',handleClick)
addContent()
          })
    },[sideDiv,saveBtnShown,contentDlt,contentInsert,contentEdit,saved,setOpenSideDiv] );

  

 function handleContentDlt (e) {
  
  const plc = e.target.offsetParent.id

    const endpoint =  `https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_content_delete?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}&NewsletterNo=${newsletterNo}&content_placeholder=${plc} `
fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then((result) => {
         setChosenTemplate(result.NewBody)
         setContentDlt(true)
         setSaved((current => !current))
      })
  }
    useEffect(() => {
       
      const contentItems = document.querySelectorAll('.content_item')  
         let close_btn = document.createElement('button')
              close_btn.innerHTML='X' 
              close_btn.className='close'
              close_btn.style.position='absolute'
              close_btn.style.top=0
              close_btn.style.right=0     
      contentItems.forEach(item => {
     
     
        item.addEventListener('mousemove', (e) => {
         
          item.style.border='1px solid red'
          item.style.position='relative'
          if(!item.querySelector('.close-btn')) {
              item.appendChild(close_btn)          
           }
               
            })
              item.addEventListener('mouseout', (e) => {
              item.style.border='none'
              item.removeChild(close_btn)
         })
      }) // for each endin
         close_btn.addEventListener('click', handleContentDlt)
       

    }, [chosenTemplate,editDiv]);

      
              
  const inputFileChanged = (e) => {
    
      setChosenFile(e.target.files[0].name)
       const file = e.target.files[0];
  const localUrl = URL.createObjectURL(file); // e.g. "blob:http://localhost:3000/abc-123"
  setPreviewUrl(localUrl);
 
  }

    const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`


  return (
     <section style={{display:sideDiv == 'undefined' || sideDiv === true | saveBtnShown === false  ? 'grid' : '',gridTemplateColumns:sideDiv == 'undefined'|| sideDiv === true || saveBtnShown === false ? '1fr 1fr':'',paddingLeft:sideDiv == 'undefined' ?'55px':'',padding:'30px 0px'}}>

         <main  >
          {chosenTemplate ?   
             <div  dangerouslySetInnerHTML={{ __html: chosenTemplate }}></div>
             : null}
         </main>
       
        {openSideDiv === true ? (
          <div>
            <aside className="asideContainer" style={{marginRight:'1px'}}>
              { (chosenInhold === 1  ) ?
              <section style={{position:'relative'}}>
                  <div style={{backgroundColor:'white',width:'500px',margin:'20px 27px',height:'398px',border:'1px solid #ccc'}}>
                       <ReactQuill theme="snow" value={editText} onChange={setEditText} />
                                
                  </div>
                    <div style={{position:'absolute',bottom:'-48px',right:'27px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               
               : (chosenInhold === 2) ?
               <section>
     
                <div className="chooseContentFilm" style={{margin:'23px 30px 10px 36px'}}>
                  <p className="content_title">Indsæt billede</p>
                  <div className="chooseFileContainer" id="drop_zone" onDrop={onDropHandler} onDragOver={onDragOver} >
                    <div style={{display:'flex'}} >
                     <label for="file-upload" class="custom-file-upload">  {chosenFile}</label>
                  
                     <input id="file-upload" type="file" onChange={(e) => inputFileChanged(e)}/>
                     <div className="uploadImgDiv" style={{}}><img src={upload} alt="" /></div>
                 
                   </div>
                     {/* <img style={{width:'100%',zIndex:1,position:'relative'}} src={previewUrl} alt='preview'/> */}

                   <p className="drop-here-text">eller træk fil til dette felt</p>
                    <div style={{fontSize:'12px',marginTop:'-25px',color:'green'}}>{files[0] && files[0].name}</div>
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',marginTop:'50px',marginRight:'16px'}}>
                    <p className="img_arkiv">Billedearkiv</p>
                   <form  className="form " style={{ width: "179px",  }} >
              <div className="movieListBox" >
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                 value='Nyeste først'
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    // width: "179px",
                   // backgroundColor: "#f7f7f7",
                    backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
                 <option>Nyeste først</option>
                </select>
              </div>
                   </form>
                  </div>
                  <div className="ImgContainer" style={{marginTop:'16px',borderTop:'1px solid #f7f7f7'}}>

                    {/* <div className="image_arkiv_div">
                      <img style={{height:'70px',width:'52px'}} src={movie} alt="" />
                      <div style={{marginTop:'10px'}}> 
                        <p style={{marginTop:'10px',fontSize:'12px',fontWeight:700,letterSpacing:'0.24px',color:'#101010'}}>movie name</p><p style={{margin:0,fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',color:'#46484c'}}>Uploadet 8/12/24</p></div>
                      <img src={deleteIcon} alt="" style={{marginTop:'25px'}}/>
                    </div> */}
                    {data && data.map((item) => (
                    <div className="image_arkiv_div">
                      <img style={{height:'70px',width:'52px'}}  src={`https://ebillet.dk/poster/`+item.poster.large}  name={item.name}  alt={item.name}  />
                      <div style={{marginTop:'10px'}}> 
                        <p style={{marginTop:'10px',fontSize:'12px',fontWeight:700,letterSpacing:'0.24px',color:'#101010'}}>{item.name}</p><p style={{margin:0,fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',color:'#46484c'}}>Uploadet 8/12/24</p></div>
                      <img src={deleteIcon} alt="" style={{marginTop:'25px'}}/>
                    </div>
                    ))}
                 
                  </div>

                </div>
                  <div style={{float:'right',marginRight:'32px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               : (chosenInhold === 3  ) ?
               <section >
                <div className="chooseContentFilm">
                  <p className="content_title">Vælg film</p>
                   <div style={{ position: "relative",width:'402px' }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter film" value={q}   
                    onChange={(e) => setQ(e.target.value)}
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div className="filmImgContainer" style={{}}>
                  
                     {  (orgID || news_orgs) && search(data) && search(data).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div style={{position:'relative',border:chosenMovieNo === movie.No ? '2px solid red' : ''}}>
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name}  alt={movie.name} width='125px' height='185px' />  
                 <button className="filmImgChoose" onClick={() => setChosenMovieNo(movie.No)}>Vælg</button>                       
                    </div>
                    ))}    

                   
                </div>
                </div>
                  <div style={{float:'right',marginRight:'32px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               : (contentKey === 'd' && contentEdit === true ) ?
                <section className="chooseContentFilm">
                  <p className="content_title">Vælg trailer</p>
                   <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter trailer"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                 <div style={{position:'relative',top:'55px',float:'right'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" onClick={handleContentInsert} style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
              :

            <>  
              <div className="allContentContainer">
                <p className="content_title">Vælg inholdstype</p>
                <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter indholdstype"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div style={{  display: "flex", gap: "18px",  flexWrap: "wrap",  marginTop: "80px",  }} >
                  {templateItems.map((template) => {
                    return    <div
                    className="content_img_container" onClick={() => {setContentKey(template.No); setChosenInhold(template.ItemTypeNo)}}
                    style={{ paddingTop:template.ItemTypeNo === 3 ?  '15px' : template.ItemTypeNo === 2 ? '40px': "31px", border: contentKey === template.No ? '1px solid #982f2f'  : ''}}
                  >
                    <img src={template.ItemTypeNo === 2 ? picture : template.ItemTypeNo === 3 ? movie:  tekst} alt="" />
                    {template.ItemTypeNo === 3 ? <img src={movie2} alt='movie' /> : null }
                    <div
                      style={{
                        position: "absolute",
                        bottom: "15px",
                        width: "100%",
                        height: "22px",
                        lineHeight:'15px'
                      }}
                    >
                      <p className="img_title" style={{color: contentKey === template.No ? '#982f2f' : '',fontWeight: contentKey === 'a' ? 700 : 400}}>{template.Name}</p>
                    </div>
                  </div>
                  })}
               
           
                </div>
              </div>

            
</>
 }
            </aside>
          </div>
        ) 
        : null
        }


          
       </section>
  )
}

export default NewsletterEditing